const EXPANDED_WIDTH = 180;
const GAP = 12;
const COLLAPSE_DELAY = 1500;
let hasScrolled = false;

export function initItemcardNavigation() {
    const nav = document.querySelector('.itemcardNavigation__nav');
    if (!nav) return;

    hideEmptyNavItems(nav);
    initScrollSpy(nav);
    initPositioning(nav);
    initExpandCollapse(nav);
}

function hideEmptyNavItems(nav) {
    const section = document.querySelector('#itemcard-descriptions');
    if (!section || section.children.length === 0) {
        const link = nav.querySelector('a[href="#itemcard-descriptions"]');
        if (link) link.closest('li').style.display = 'none';
    }
}

function initScrollSpy(nav) {
    const links = nav.querySelectorAll('a[href^="#"]');
    const spyElements = document.querySelectorAll('.js-scrollSpyElement');
    if (!spyElements.length || !links.length) return;

    links[0].classList.add('is-active');
    updateHamburgerTop(nav, links[0]);

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            links.forEach(link => {
                const isActive = link.getAttribute('href') === '#' + entry.target.id;
                link.classList.toggle('is-active', isActive);
                if (isActive) updateHamburgerTop(nav, link);
            });
        });
    }, { rootMargin: '-20% 0px -75% 0px' });

    spyElements.forEach(el => observer.observe(el));
}

function updateHamburgerTop(nav, link) {
    const li = link.closest('li');
    const paddingTop = parseFloat(getComputedStyle(nav).paddingTop) || 0;
    nav.style.setProperty('--hamburger-top', (li.offsetTop - paddingTop + li.offsetHeight / 2) + 'px');
}

function initPositioning(nav) {
    const container = document.querySelector('.itemcard .container');
    if (!container) return;

    function update() {
        const containerLeft = container.getBoundingClientRect().left;
        const available = containerLeft - GAP;

        if (available >= EXPANDED_WIDTH) {
            nav.dataset.navMode = 'spacious';
            nav.style.left = (containerLeft - GAP) + 'px';
            nav.style.setProperty('--nav-expanded-width', EXPANDED_WIDTH + 'px');
            nav.classList.remove('is-collapsed');
        } else {
            if (hasScrolled && nav.dataset.navMode !== 'overlay') {
                nav.classList.add('is-collapsed');
            }
            nav.dataset.navMode = 'overlay';
            nav.style.left = '4px';
            nav.style.setProperty('--nav-expanded-width', EXPANDED_WIDTH + 'px');
        }
    }

    update();
    window.addEventListener('resize', update, { passive: true });
    new ResizeObserver(update).observe(document.documentElement);
}

function initExpandCollapse(nav) {
    let timer = null;

    function scheduleCollapse() {
        if (nav.dataset.navMode === 'spacious') return;
        clearTimeout(timer);
        timer = setTimeout(() => nav.classList.add('is-collapsed'), COLLAPSE_DELAY);
    }

    window.addEventListener('scroll', () => {
        hasScrolled = true;
        if (nav.dataset.navMode === 'spacious') return;
        if (!nav.matches(':hover')) scheduleCollapse();
    }, { passive: true });

    nav.addEventListener('mouseenter', () => {
        if (nav.dataset.navMode === 'spacious') return;
        clearTimeout(timer);
        nav.classList.remove('is-collapsed');
    });

    nav.addEventListener('mouseleave', () => {
        scheduleCollapse();
    });
}
